import BaseVariantHandler from '../shared/product/variant-handler';
import PriceHandler from '../shared/product-card/price-handler';
import LinkHandler from '../shared/product-card/link-handler';
import ImageHandler from '../shared/product/image-handler';
import ButtonHandler from '../shared/product/button-handler';
import OutOfStockHandler from '../shared/product/out-of-stock-handler';

export default class VariantHandler extends BaseVariantHandler {
  global = false;

  handlers = [
    new ImageHandler(),
    new ButtonHandler(),
    new PriceHandler(),
    new LinkHandler(),
    new OutOfStockHandler()
  ];
}
